module.exports = "<div class=\"disclaimer-wrapper\">\n\t<div class=\"home-heading\">\n\t\tDisclaimer\n\t</div>\n\n\t<div class=\"disclaimer-body\" [innerHtml]='disclaimerData'></div>\n\n\t<div class=\"next-btn-wrap next-back-btn-wrap\">\n\t\t<a class=\"btn flex-1\" (click)=\"onCancel()\">I Agree</a>\n\t\t<a class=\"btn btn-cancel flex-1\" (click)=\"gotoHome()\">Cancel(I Do Not Agree)</a>\n    </div> \n</div>"


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/disclaimer-modal/disclaimer-modal.component.html
// module id = ../../../../../src/app/modals/disclaimer-modal/disclaimer-modal.component.html
// module chunks = main